import { createAction, props } from '@ngrx/store';
import {
  ProductControllerCreateProduct$Params,
  ProductControllerFindAllProduct$Params,
  ProductControllerFindAllProductCategory$Params,
} from '../../../api/functions';
import { ILoaderActionPayload } from '../models/loader.model';
import { ProductCategoryListResponse, ProductItem, ProductListResponse } from '../../../api/models';

export const productActions = {
  // Restituisce l'elenco dei prodotti.
  loadProducts: createAction('load/products/load', props<ProductControllerFindAllProduct$Params>()),
  loadProductsDone: createAction(
    'load/products/done',
    props<{ state: ILoaderActionPayload; data?: ProductListResponse }>(),
  ),
  createProduct: createAction('create/product/create', props<ProductControllerCreateProduct$Params>()),
  createProductDone: createAction('create/product/done', props<{ state: ILoaderActionPayload; data?: ProductItem }>()),
  loadProductsCategory: createAction(
    'load/products-categories/load',
    props<ProductControllerFindAllProductCategory$Params>(),
  ),
  loadProductsCategoryDone: createAction(
    'load/products-categories/done',
    props<{ state: ILoaderActionPayload; data?: ProductCategoryListResponse }>(),
  ),
};
